module.exports = fox._r("images/violet-star.png", __webpack_public_path__ + "images/violet-star.png");


//////////////////
// WEBPACK FOOTER
// ./images/violet-star.png
// module id = 502
// module chunks = 2